import styled, { css } from "styled-components";

interface NavItemStyleProps {
  $pathnameSync?: boolean;
}

export const NavBtn = styled.button`
  display: flex;
  width: 100%;
  height: 60px;
  background: none;
  border: none;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
`;

export const NavBtnIcon = styled.div`
  width: 28px;
  height: 28px;

  svg {
    & > path:last-of-type {
      fill: ${(props) => props.theme.colors.black12};
    }

    g {
      circle {
        fill: ${(props) => props.theme.colors.black12};
      }

      path {
        fill: ${(props) => props.theme.colors.black12};
      }
    }
  }
`;

export const NavBtnTitle = styled.span`
  height: 12px;
  color: ${(props) => props.theme.colors.black60};
  vertical-align: middle;
`;

export const NavItem = styled.li<NavItemStyleProps>`
  width: 100%;
  border-radius: 6px;

  &:active {
    background: ${(props) => props.theme.colors.primary5};
  }

  ${(props) =>
    props.$pathnameSync === true &&
    css`
      ${NavBtnIcon} {
        svg {
          & > path:last-of-type {
            fill: ${(props) => props.theme.colors.primary100};
          }

          g {
            circle {
              fill: ${(props) => props.theme.colors.primary100};
            }

            path {
              fill: ${(props) => props.theme.colors.primary100};
            }
          }
        }
      }

      ${NavBtnTitle} {
        color: ${(props) => props.theme.colors.primary100};
        font-weight: 800;
      }
    `}
`;
